import React, { useState, useEffect, useRef } from 'react';
import { softDelete, softDeleteHijos } from '../utils/softDelete';
import { supabase } from '../supabase';
import ExpedienteDetalle from './ExpedienteDetalle';
import { useEsAdmin } from '../UserContext';
import { onEntidadChanged } from '../utils/entidadBus';
import { onDataChanged } from '../utils/dataBus';

export default function Expedientes() {
  const esAdmin = useEsAdmin();
  const mouseDownPos = useRef(null);
  const [expedientes, setExpedientes] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filtroFuero, setFiltroFuero] = useState('');
  const [orden, setOrden] = useState('mas_nuevos');
  const [modalOpen, setModalOpen] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [toast, setToast] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [expedienteSeleccionado, setExpedienteSeleccionado] = useState(null);
  const [busquedaCliente, setBusquedaCliente] = useState('');
  const [dropdownClienteOpen, setDropdownClienteOpen] = useState(false);
  const [modalConfirmOpen, setModalConfirmOpen] = useState(null);
  const [modalCrearCliente, setModalCrearCliente] = useState(false);
  const [formCrearCliente, setFormCrearCliente] = useState({ nombre: '', apellido: '', telefono: '', email: '' });
  const [guardandoCliente, setGuardandoCliente] = useState(false);
  const [busquedaPrincipal, setBusquedaPrincipal] = useState('');
  const [dropdownPrincipalOpen, setDropdownPrincipalOpen] = useState(false);
  const [principalSeleccionado, setPrincipalSeleccionado] = useState(null);
  const [modalCrearPrincipal, setModalCrearPrincipal] = useState(false);
  const [formCrearPrincipal, setFormCrearPrincipal] = useState({ numero: '', caratula: '', fuero: '', juzgado: '', posicion_procesal: 'actor' });
  const [guardandoPrincipal, setGuardandoPrincipal] = useState(false);

  const [form, setForm] = useState({
    numero: '', caratula: '', fuero: '', juzgado: '', posicion_procesal: 'actor', cliente_ids: [],
    tipo: 'principal', expediente_principal_id: ''
  });

  useEffect(() => { fetchExpedientes(); fetchClientes(); }, []);

  // Refrescar si un cliente o expediente (ej: un incidente eliminado desde un drawer anidado) cambia desde otro lugar
  useEffect(() => onEntidadChanged((d) => { if (d.tipo === 'cliente' || d.tipo === 'expediente') fetchExpedientes(); }), []);

  // Automático: cualquier escritura sobre expedientes o clientes (crear, editar, eliminar)
  useEffect(() => onDataChanged(() => { fetchExpedientes(); fetchClientes(); }, ['expedientes', 'clientes', 'expedientes_clientes']), []);

  async function fetchExpedientes() {
    setLoading(true);
    const { data } = await supabase
      .from('expedientes')
      .select('*, expedientes_clientes(cliente_id, clientes(nombre, apellido))')
      .eq('eliminado', false)
      .order('created_at', { ascending: false });
    setExpedientes(data || []);
    setLoading(false);
  }

  function agruparConIncidentes(lista) {
    const principales = lista.filter(e => !e.expediente_principal_id);
    const incidentes = lista.filter(e => e.expediente_principal_id);
    const resultado = [];
    principales.forEach(p => {
      resultado.push({ ...p, _esIncidente: false });
      incidentes.filter(i => i.expediente_principal_id === p.id).forEach(i => resultado.push({ ...i, _esIncidente: true }));
    });
    // incidentes cuyo principal no está en la lista filtrada actual
    incidentes.filter(i => !principales.find(p => p.id === i.expediente_principal_id)).forEach(i => resultado.push({ ...i, _esIncidente: true }));
    return resultado;
  }

  async function fetchClientes() {
    const { data } = await supabase.from('clientes').select('id, nombre, apellido').eq('eliminado', false).order('nombre');
    setClientes(data || []);
  }

  function showToast(msg, type = 'success') {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  }

  function openDrawer(exp) {
    setExpedienteSeleccionado(exp.id);
    setDrawerOpen(true);
  }

  function openNew() {
    setForm({ numero: '', caratula: '', fuero: '', juzgado: '', posicion_procesal: 'actor', cliente_ids: [], tipo: 'principal', expediente_principal_id: '', prueba_habilitada: true });
    setBusquedaCliente('');
    setBusquedaPrincipal('');
    setPrincipalSeleccionado(null);
    setModalOpen(true);
  }

  async function guardarNuevoPrincipal() {
    if (!formCrearPrincipal.caratula.trim()) return;
    setGuardandoPrincipal(true);
    const { data: nuevo } = await supabase.from('expedientes').insert({
      caratula: formCrearPrincipal.caratula.trim(),
      numero: formCrearPrincipal.numero.trim() || null,
      fuero: formCrearPrincipal.fuero || null,
      juzgado: formCrearPrincipal.juzgado.trim() || null,
      posicion_procesal: formCrearPrincipal.posicion_procesal,
    }).select('id, caratula, numero, fuero, juzgado').single();
    if (nuevo) {
      await fetchExpedientes();
      setPrincipalSeleccionado(nuevo);
      setForm(f => ({
        ...f,
        expediente_principal_id: nuevo.id,
        fuero: nuevo.fuero || f.fuero,
        juzgado: nuevo.juzgado || f.juzgado,
      }));
      setBusquedaPrincipal('');
    }
    setGuardandoPrincipal(false);
    setModalCrearPrincipal(false);
    setFormCrearPrincipal({ numero: '', caratula: '', fuero: '', juzgado: '', posicion_procesal: 'actor' });
  }

  async function guardarNuevoCliente() {
    if (!formCrearCliente.nombre.trim()) return;
    setGuardandoCliente(true);
    const { data: nuevo } = await supabase.from('clientes')
      .insert({ nombre: formCrearCliente.nombre.trim(), apellido: formCrearCliente.apellido.trim() || null, email: formCrearCliente.email.trim() || null, estado: 'activo' })
      .select('id, nombre, apellido').single();
    if (nuevo) {
      if (formCrearCliente.telefono.trim()) {
        await supabase.from('clientes_telefonos').insert({ cliente_id: nuevo.id, tipo: 'Celular', numero: formCrearCliente.telefono.trim() });
      }
      await fetchClientes();
      setForm(f => ({ ...f, cliente_ids: [...f.cliente_ids, nuevo.id] }));
    }
    setGuardandoCliente(false);
    setModalCrearCliente(false);
    setFormCrearCliente({ nombre: '', apellido: '', telefono: '', email: '' });
  }

  async function saveExpediente() {
    if (guardando) return;
    if (!form.caratula.trim()) { showToast('La carátula es obligatoria'); return; }
    setGuardando(true);
    if (form.tipo === 'incidente' && !form.expediente_principal_id) { showToast('Seleccioná o creá el expediente principal'); setGuardando(false); return; }
    const { data: nuevo, error } = await supabase.from('expedientes').insert({
      caratula: form.caratula,
      numero: form.numero || null,
      fuero: (form.fuero && form.fuero !== '__otro__') ? form.fuero : null,
      juzgado: form.juzgado || null,
      posicion_procesal: form.posicion_procesal,
      expediente_principal_id: form.tipo === 'incidente' ? form.expediente_principal_id : null,
      prueba_habilitada: form.prueba_habilitada,
    }).select('id').single();
    if (error || !nuevo) { showToast('Error al guardar'); setGuardando(false); return; }
    if (form.cliente_ids.length > 0) {
      await supabase.from('expedientes_clientes').insert(
        form.cliente_ids.map(cid => ({ expediente_id: nuevo.id, cliente_id: cid }))
      );
    }
    showToast('Expediente creado ✓');
    setGuardando(false);
    setModalOpen(false);
    fetchExpedientes();
  }

  async function deleteExpediente(id, e) {
    e.stopPropagation();
    const exp = expedientes.find(e => e.id === id);
    setModalConfirmOpen({ id, caratula: exp.caratula });
  }

  async function confirmarDeleteExpediente(accion, id, caratula) {
    setModalConfirmOpen(null);
    if (accion === 'eliminar') {
      setExpedientes(prev => prev.filter(e => e.id !== id));
      if (expedienteSeleccionado === id) { setExpedienteSeleccionado(null); setDrawerOpen(false); }
      const now = new Date().toISOString();
      await Promise.all([
        softDeleteHijos('tareas', 'expediente_id', id),
        softDeleteHijos('agenda', 'expediente_id', id),
        softDeleteHijos('movimientos', 'expediente_id', id),
        softDeleteHijos('expedientes_notas', 'expediente_id', id),
        softDeleteHijos('expediente_pruebas', 'expediente_id', id),
      ]);
      const { error } = await softDelete('expedientes', id);
      if (error) { showToast('Error al eliminar'); fetchExpedientes(); return; }
      showToast('Expediente enviado a la papelera');
    } else if (accion === 'archivar') {
      setExpedientes(prev => prev.map(e => e.id === id ? { ...e, estado_procesal: 'Archivado' } : e));
      const { error } = await supabase.from('expedientes').update({ estado_procesal: 'Archivado' }).eq('id', id);
      if (error) { showToast('Error al archivar'); fetchExpedientes(); return; }
      showToast('Expediente archivado ✓');
    }
  }

  function toggleCliente(id) {
    setForm(f => ({
      ...f,
      cliente_ids: f.cliente_ids.includes(id)
        ? f.cliente_ids.filter(c => c !== id)
        : [...f.cliente_ids, id]
    }));
  }

  const filtered = agruparConIncidentes(expedientes.filter(e => {
    const s = search.toLowerCase();
    const matchSearch = !s ||
      e.caratula?.toLowerCase().includes(s) ||
      e.numero?.toLowerCase().includes(s) ||
      e.parte_contraria?.toLowerCase().includes(s) ||
      e.letrado_contrario?.toLowerCase().includes(s) ||
      e.juzgado?.toLowerCase().includes(s);
    const matchFuero = !filtroFuero || e.fuero === filtroFuero;
    return matchSearch && matchFuero;
  }).sort((a, b) => {
    switch (orden) {
      case 'alfabetico':     return (a.caratula || '').localeCompare(b.caratula || '', 'es');
      case 'alfabetico_inv': return (b.caratula || '').localeCompare(a.caratula || '', 'es');
      case 'mas_nuevos':     return (b.created_at || '').localeCompare(a.created_at || '');
      case 'mas_antiguos':   return (a.created_at || '').localeCompare(b.created_at || '');
      case 'fuero':          return (a.fuero || '').localeCompare(b.fuero || '', 'es');
      default:               return 0;
    }
  }));

  const posicionBadge = (p) => (
    <span className={`badge ${p === 'actor' ? 'badge-green' : 'badge-amber'}`}>
      {p === 'actor' ? 'Actor' : 'Demandado'}
    </span>
  );

  const formatDate = (d) => d ? new Date(d + 'T12:00:00').toLocaleDateString('es-AR') : '—';

  return (
    <div className="page">
      <div className="page-topbar">
        <div className="flex" style={{ alignItems: 'center' }}>
          <span className="page-title">Expedientes</span>
          <span className="page-subtitle">— {filtered.length} causa{filtered.length !== 1 ? 's' : ''}</span>
        </div>
        <div className="flex gap-2">
          <button className="btn btn-primary" onClick={openNew}>+ Nuevo expediente</button>
        </div>
      </div>

      <div className="page-content">
        <div className="toolbar">
          <div className="search-box">
            <span style={{ color: 'var(--text4)' }}>⌕</span>
            <input placeholder="Buscar por carátula, número, parte contraria..." value={search} onChange={e => setSearch(e.target.value)} autoComplete="off" spellCheck={false} />
            {search && <button onClick={() => setSearch('')} style={{ background: 'none', border: 'none', color: 'var(--text4)', cursor: 'pointer', padding: '0 2px', fontSize: 16, lineHeight: 1, flexShrink: 0 }}>×</button>}
          </div>
          <select className="filter-select" value={filtroFuero} onChange={e => setFiltroFuero(e.target.value)}>
            <option value="">Todos los fueros</option>
            <option>Civil</option><option>Penal</option><option>Laboral</option>
            <option>Familia</option><option>Contencioso Administrativo</option>
            <option>Comercial</option><option>Sucesorio</option>
          </select>
        </div>

        <div className="card">
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 16px', borderBottom: '1px solid var(--border)' }}>
            <span style={{ fontSize: 12, color: 'var(--text4)', fontWeight: 500 }}>Ordenar por:</span>
            <select className="filter-select" value={orden} onChange={e => setOrden(e.target.value)} style={{ fontSize: 12, minWidth: 240 }}>
              <option value="alfabetico">Alfabético (A → Z)</option>
              <option value="alfabetico_inv">Alfabético (Z → A)</option>
              <option value="mas_nuevos">Creación (más recientes)</option>
              <option value="mas_antiguos">Creación (más antiguos)</option>
              <option value="fuero">Por fuero</option>
            </select>
          </div>
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>N° / Carátula</th>
                  <th>Clientes</th>
                  <th>Fuero</th>
                  <th>Posición</th>
                  <th>Estado procesal</th>
                  <th>Últ. movimiento</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan="6" style={{ textAlign: 'center', padding: 40, color: 'var(--text4)' }}>Cargando...</td></tr>
                ) : filtered.length === 0 ? (
                  <tr><td colSpan="6">
                    <div className="empty-state">
                      <div className="empty-state-icon">📁</div>
                      <div className="empty-state-title">No hay expedientes</div>
                      <div>Creá el primero con el botón "Nuevo expediente"</div>
                    </div>
                  </td></tr>
                ) : filtered.map(e => (
                  <tr key={e.id} style={{ cursor: 'pointer', background: e._esIncidente ? 'var(--surface2)' : undefined }}
                    onMouseDown={ev => { mouseDownPos.current = { x: ev.clientX, y: ev.clientY }; }}
                    onClick={ev => {
                      if (mouseDownPos.current) {
                        const dx = Math.abs(ev.clientX - mouseDownPos.current.x);
                        const dy = Math.abs(ev.clientY - mouseDownPos.current.y);
                        if (dx > 5 || dy > 5) return;
                      }
                      openDrawer(e);
                    }}>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        {e._esIncidente && <span style={{ fontSize: 9, background: '#f3e8ff', color: '#7c3aed', borderRadius: 4, padding: '1px 6px', fontWeight: 700, flexShrink: 0 }}>INCIDENTE</span>}
                        <div>
                          <div className="td-primary" style={{ paddingLeft: e._esIncidente ? 0 : undefined }}>{e._esIncidente ? '↳ ' : ''}{e.caratula}</div>
                          <div className="td-sub td-mono">{e.numero || 'S/N'}</div>
                        </div>
                      </div>
                    </td>
                    <td style={{ fontSize: 12 }}>
                      {e.expedientes_clientes?.map(ec =>
                        `${ec.clientes?.nombre || ''} ${ec.clientes?.apellido || ''}`
                      ).join(', ') || '—'}
                    </td>
                    <td>{e.fuero ? <span className="badge badge-blue">{e.fuero}</span> : '—'}</td>
                    <td>{posicionBadge(e.posicion_procesal)}</td>
                    <td>{e.estado_procesal ? <span className="badge badge-gray">{e.estado_procesal}</span> : '—'}</td>
                    <td style={{ fontSize: 12, color: 'var(--text4)' }}>{formatDate(e.fecha_ultimo_movimiento)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* DRAWER */}
      {drawerOpen && (
        <>
          <div className="drawer-overlay" onMouseDown={() => setDrawerOpen(false)} />
          <div className="drawer">
            <ExpedienteDetalle
              expedienteId={expedienteSeleccionado}
              onClose={() => setDrawerOpen(false)}
              onUpdate={fetchExpedientes}
              onNavigateExpediente={(id) => setExpedienteSeleccionado(id)}
            />
          </div>
        </>
      )}

      {/* MODAL NUEVO EXPEDIENTE */}
      {modalOpen && (
        <div className="modal-overlay" onMouseDown={e => e.target === e.currentTarget && setModalOpen(false)}>
          <div className="modal" style={{ width: 520 }} onKeyDown={e => { if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA' && e.target.tagName !== 'SELECT') saveExpediente(); }}>
            <div className="modal-header">
              <div className="modal-title">Nuevo expediente</div>
              <button className="modal-close" onClick={() => setModalOpen(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-grid">
                {/* TIPO: PRINCIPAL / INCIDENTE */}
                <div className="form-group form-full">
                  <label className="form-label">Tipo</label>
                  <div style={{ display: 'flex', gap: 0, borderRadius: 8, overflow: 'hidden', border: '1px solid var(--border)', width: 'fit-content' }}>
                    {['principal', 'incidente'].map(t => (
                      <button
                        key={t}
                        type="button"
                        onClick={() => {
                          setForm(f => ({ ...f, tipo: t, expediente_principal_id: '' }));
                          setPrincipalSeleccionado(null);
                          setBusquedaPrincipal('');
                        }}
                        style={{
                          padding: '6px 20px', fontSize: 13, fontWeight: 600, border: 'none', cursor: 'pointer',
                          background: form.tipo === t ? 'var(--blue)' : 'var(--surface2)',
                          color: form.tipo === t ? '#fff' : 'var(--text3)',
                          transition: 'background 0.15s',
                        }}
                      >
                        {t === 'principal' ? 'Principal' : 'Incidente'}
                      </button>
                    ))}
                  </div>
                </div>

                {/* SECCIÓN PRINCIPAL CUANDO ES INCIDENTE */}
                {form.tipo === 'incidente' && (
                  <div className="form-group form-full">
                    <label className="form-label">Expediente principal *</label>
                    {principalSeleccionado ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', borderRadius: 8, background: '#f3e8ff', border: '1px solid #c4b5fd' }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 13, fontWeight: 600, color: '#5b21b6' }}>{principalSeleccionado.caratula}</div>
                          {principalSeleccionado.numero && <div style={{ fontSize: 11, color: '#7c3aed' }}>{principalSeleccionado.numero}</div>}
                        </div>
                        <span
                          onClick={() => { setPrincipalSeleccionado(null); setForm(f => ({ ...f, expediente_principal_id: '' })); }}
                          style={{ cursor: 'pointer', color: '#7c3aed', fontWeight: 700, fontSize: 16 }}
                        >×</span>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', gap: 8 }}>
                        <div style={{ position: 'relative', flex: 1 }}>
                          <input
                            className="form-input"
                            placeholder="Buscar expediente principal por carátula o número..."
                            value={busquedaPrincipal}
                            onChange={e => setBusquedaPrincipal(e.target.value)}
                            onFocus={() => setDropdownPrincipalOpen(true)}
                            onBlur={() => setTimeout(() => setDropdownPrincipalOpen(false), 150)}
                            autoComplete="off" spellCheck={false}
                          />
                          {dropdownPrincipalOpen && (
                            <div style={{ position: 'absolute', bottom: '100%', left: 0, right: 0, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 8, zIndex: 200, maxHeight: 200, overflowY: 'auto', marginBottom: 4, boxShadow: '0 -4px 16px rgba(0,0,0,0.3)' }}>
                              {expedientes.filter(e => !e.expediente_principal_id && (() => {
                                const t = busquedaPrincipal.toLowerCase();
                                return !t || e.caratula?.toLowerCase().includes(t) || e.numero?.toLowerCase().includes(t);
                              })()).map(e => (
                                <div
                                  key={e.id}
                                  onMouseDown={() => {
                                    setPrincipalSeleccionado(e);
                                    setForm(f => ({ ...f, expediente_principal_id: e.id, fuero: e.fuero || f.fuero, juzgado: e.juzgado || f.juzgado }));
                                    setBusquedaPrincipal('');
                                    setDropdownPrincipalOpen(false);
                                  }}
                                  style={{ padding: '8px 14px', cursor: 'pointer', fontSize: 13, borderBottom: '1px solid var(--border)' }}
                                >
                                  <div style={{ fontWeight: 500, color: 'var(--text2)' }}>{e.caratula}</div>
                                  {e.numero && <div style={{ fontSize: 11, color: 'var(--text4)' }}>{e.numero}</div>}
                                </div>
                              ))}
                              {expedientes.filter(e => !e.expediente_principal_id && (() => {
                                const t = busquedaPrincipal.toLowerCase();
                                return !t || e.caratula?.toLowerCase().includes(t) || e.numero?.toLowerCase().includes(t);
                              })()).length === 0 && (
                                <div style={{ padding: '10px 14px', color: 'var(--text4)', fontSize: 13 }}>Sin resultados</div>
                              )}
                            </div>
                          )}
                        </div>
                        <button type="button" className="btn btn-ghost" onClick={() => { setFormCrearPrincipal({ numero: '', caratula: '', fuero: '', juzgado: '', posicion_procesal: 'actor' }); setModalCrearPrincipal(true); }} style={{ flexShrink: 0, fontSize: 12, whiteSpace: 'nowrap' }}>+ Crear principal</button>
                      </div>
                    )}
                  </div>
                )}

                <div className="form-group form-full">
                  <label className="form-label">Carátula *</label>
                  <input className="form-input" autoFocus value={form.caratula} onChange={e => setForm(f => ({ ...f, caratula: e.target.value }))} placeholder="Ej: García c/ López s/ Daños y Perjuicios" />
                </div>
                <div className="form-group">
                  <label className="form-label">N° Expediente</label>
                  <input className="form-input" value={form.numero} onChange={e => setForm(f => ({ ...f, numero: e.target.value }))} placeholder="Ej: 12345/2024" />
                </div>
                <div className="form-group">
                  <label className="form-label">Posición procesal</label>
                  <select className="form-select" value={form.posicion_procesal} onChange={e => setForm(f => ({ ...f, posicion_procesal: e.target.value }))}>
                    <option value="actor">Actor</option>
                    <option value="demandado">Demandado</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Fuero</label>
                  {(() => {
                    const FUEROS_CONOCIDOS = ['Civil', 'Penal', 'Laboral', 'Familia', 'Contencioso Administrativo', 'Comercial', 'Sucesorio'];
                    const enModoLibre = form.fuero !== '' && !FUEROS_CONOCIDOS.includes(form.fuero);
                    if (!enModoLibre) {
                      return (
                        <select className="form-select" value={form.fuero} onChange={e => setForm(f => ({ ...f, fuero: e.target.value }))}>
                          <option value="">Seleccioná</option>
                          {FUEROS_CONOCIDOS.map(f => <option key={f}>{f}</option>)}
                          <option value="__otro__">Otro...</option>
                        </select>
                      );
                    }
                    // Modo libre: input de texto
                    const valorVisible = form.fuero === '__otro__' ? '' : form.fuero;
                    return (
                      <div style={{ display: 'flex', gap: 6 }}>
                        <input
                          className="form-input"
                          autoFocus
                          value={valorVisible}
                          onChange={e => setForm(f => ({ ...f, fuero: e.target.value || '__otro__' }))}
                          placeholder="Especificá el fuero"
                        />
                        <button className="btn btn-ghost btn-sm" title="Volver a la lista" onClick={() => setForm(f => ({ ...f, fuero: '' }))}>✕</button>
                      </div>
                    );
                  })()}
                </div>
                <div className="form-group">
                  <label className="form-label">Juzgado / Tribunal</label>
                  <input className="form-input" value={form.juzgado} onChange={e => setForm(f => ({ ...f, juzgado: e.target.value }))} placeholder="Ej: Juzgado Civil N° 5" />
                </div>
                <div className="form-group form-full">
                  <label className="form-label" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    ¿Tiene etapa de prueba?
                    <InfoTooltip text="Habilitar esta función permite seguimiento de la producción de prueba registros de movimientos, audiencias y vencimientos asociados" />
                  </label>
                  <div style={{ display: 'flex', gap: 8 }}>
                    {[{ v: true, label: 'Sí' }, { v: false, label: 'No' }].map(({ v, label }) => (
                      <button
                        key={String(v)}
                        type="button"
                        className={`btn btn-sm ${form.prueba_habilitada === v ? 'btn-primary' : 'btn-ghost'}`}
                        onClick={() => setForm(f => ({ ...f, prueba_habilitada: v }))}
                      >
                        {label}
                      </button>
                    ))}
                  </div>
                  {!form.prueba_habilitada && (
                    <div style={{ fontSize: 11, color: 'var(--text4)', marginTop: 6 }}>La pestaña Prueba no va a aparecer en este expediente.</div>
                  )}
                </div>
                <div className="form-group form-full">
                  <label className="form-label">Clientes vinculados</label>
                  {form.cliente_ids.length > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 8 }}>
                      {form.cliente_ids.map(id => {
                        const c = clientes.find(x => x.id === id);
                        return c ? (
                          <div key={id} style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '3px 10px', borderRadius: 20, background: 'var(--blue-light)', border: '1px solid var(--blue)', color: 'var(--blue)', fontSize: 12 }}>
                            {c.nombre} {c.apellido}
                            <span onClick={() => toggleCliente(id)} style={{ cursor: 'pointer', fontWeight: 700, marginLeft: 2 }}>×</span>
                          </div>
                        ) : null;
                      })}
                    </div>
                  )}
                  <div style={{ display: 'flex', gap: 8 }}>
                    <div style={{ position: 'relative', flex: 1 }}>
                      <input
                        className="form-input"
                        placeholder="Buscar cliente por nombre o DNI..."
                        value={busquedaCliente}
                        onChange={e => setBusquedaCliente(e.target.value)}
                        onFocus={() => setDropdownClienteOpen(true)}
                        onBlur={() => setTimeout(() => setDropdownClienteOpen(false), 150)}
                        autoComplete="off" spellCheck={false}
                      />
                      {dropdownClienteOpen && (
                        <div style={{ position: 'absolute', bottom: '100%', left: 0, right: 0, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 8, zIndex: 200, maxHeight: 200, overflowY: 'auto', marginBottom: 4, boxShadow: '0 -4px 16px rgba(0,0,0,0.3)' }}>
                          {clientes.filter(c => {
                            const t = busquedaCliente.toLowerCase();
                            return !t || `${c.nombre} ${c.apellido}`.toLowerCase().includes(t) || (c.dni || '').includes(t);
                          }).map(c => (
                            <div key={c.id} onMouseDown={() => { toggleCliente(c.id); setBusquedaCliente(''); }}
                              style={{ padding: '8px 14px', cursor: 'pointer', fontSize: 13, display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                background: form.cliente_ids.includes(c.id) ? 'var(--blue-light)' : 'transparent',
                                color: form.cliente_ids.includes(c.id) ? 'var(--blue)' : 'var(--text2)' }}>
                              <span>{c.nombre} {c.apellido}{c.dni ? <span style={{ fontSize: 11, color: 'var(--text4)', marginLeft: 8 }}>{c.dni}</span> : ''}</span>
                              {form.cliente_ids.includes(c.id) && <span>✓</span>}
                            </div>
                          ))}
                          {clientes.filter(c => { const t = busquedaCliente.toLowerCase(); return !t || `${c.nombre} ${c.apellido}`.toLowerCase().includes(t); }).length === 0 && (
                            <div style={{ padding: '10px 14px', color: 'var(--text4)', fontSize: 13 }}>Sin resultados</div>
                          )}
                        </div>
                      )}
                    </div>
                    <button type="button" className="btn btn-ghost" onClick={() => { setFormCrearCliente({ nombre: busquedaCliente, apellido: '', telefono: '', email: '' }); setModalCrearCliente(true); }} style={{ flexShrink: 0, fontSize: 12, whiteSpace: 'nowrap' }}>+ Crear nuevo cliente</button>
                  </div>
                </div>
              </div>
              <div style={{ fontSize: 11, color: 'var(--text4)', marginTop: 10, padding: '8px 12px', background: 'var(--surface2)', borderRadius: 7 }}>
                💡 Podés completar juez, partes, fechas y demás datos desde la ficha del expediente.
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={() => setModalOpen(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={saveExpediente} disabled={guardando}>{guardando ? 'Guardando...' : 'Crear expediente'}</button>
            </div>
          </div>
        </div>
      )}

      {/* MINI-MODAL CREAR CLIENTE */}
      {modalCrearCliente && (
        <div className="modal-overlay" onMouseDown={e => e.target === e.currentTarget && setModalCrearCliente(false)} style={{ zIndex: 9999 }}>
          <div className="modal" style={{ width: 420 }}>
            <div className="modal-header">
              <div className="modal-title">Nuevo cliente</div>
              <button className="modal-close" onClick={() => setModalCrearCliente(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-grid">
                <div className="form-group">
                  <label className="form-label">Nombre *</label>
                  <input className="form-input" autoFocus value={formCrearCliente.nombre} onChange={e => setFormCrearCliente(f => ({ ...f, nombre: e.target.value }))} placeholder="Nombre" />
                </div>
                <div className="form-group">
                  <label className="form-label">Apellido</label>
                  <input className="form-input" value={formCrearCliente.apellido} onChange={e => setFormCrearCliente(f => ({ ...f, apellido: e.target.value }))} placeholder="Apellido" />
                </div>
                <div className="form-group">
                  <label className="form-label">Teléfono</label>
                  <input className="form-input" value={formCrearCliente.telefono} onChange={e => setFormCrearCliente(f => ({ ...f, telefono: e.target.value }))} placeholder="Celular" />
                </div>
                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input className="form-input" type="email" value={formCrearCliente.email} onChange={e => setFormCrearCliente(f => ({ ...f, email: e.target.value }))} placeholder="email@ejemplo.com" />
                </div>
              </div>
              <div style={{ fontSize: 11, color: 'var(--text4)', marginTop: 10 }}>Podés completar el resto desde la sección Clientes.</div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={() => setModalCrearCliente(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={guardarNuevoCliente} disabled={guardandoCliente || !formCrearCliente.nombre.trim()}>
                {guardandoCliente ? 'Guardando...' : 'Crear y vincular'}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* MINI-MODAL CREAR EXPEDIENTE PRINCIPAL */}
      {modalCrearPrincipal && (
        <div className="modal-overlay" onMouseDown={e => e.target === e.currentTarget && setModalCrearPrincipal(false)} style={{ zIndex: 9999 }}>
          <div className="modal" style={{ width: 480 }}>
            <div className="modal-header">
              <div className="modal-title">Nuevo expediente principal</div>
              <button className="modal-close" onClick={() => setModalCrearPrincipal(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-grid">
                <div className="form-group form-full">
                  <label className="form-label">Carátula *</label>
                  <input className="form-input" autoFocus value={formCrearPrincipal.caratula} onChange={e => setFormCrearPrincipal(f => ({ ...f, caratula: e.target.value }))} placeholder="Ej: García c/ López s/ Daños y Perjuicios" />
                </div>
                <div className="form-group">
                  <label className="form-label">N° Expediente</label>
                  <input className="form-input" value={formCrearPrincipal.numero} onChange={e => setFormCrearPrincipal(f => ({ ...f, numero: e.target.value }))} placeholder="Ej: 12345/2024" />
                </div>
                <div className="form-group">
                  <label className="form-label">Posición procesal</label>
                  <select className="form-select" value={formCrearPrincipal.posicion_procesal} onChange={e => setFormCrearPrincipal(f => ({ ...f, posicion_procesal: e.target.value }))}>
                    <option value="actor">Actor</option>
                    <option value="demandado">Demandado</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Fuero</label>
                  <select className="form-select" value={formCrearPrincipal.fuero} onChange={e => setFormCrearPrincipal(f => ({ ...f, fuero: e.target.value }))}>
                    <option value="">Seleccioná</option>
                    <option>Civil</option><option>Penal</option><option>Laboral</option>
                    <option>Familia</option><option>Contencioso Administrativo</option>
                    <option>Comercial</option><option>Sucesorio</option>
                  </select>
                </div>
                <div className="form-group form-full">
                  <label className="form-label">Juzgado / Tribunal</label>
                  <input className="form-input" value={formCrearPrincipal.juzgado} onChange={e => setFormCrearPrincipal(f => ({ ...f, juzgado: e.target.value }))} placeholder="Ej: Juzgado Civil N° 5" />
                </div>
              </div>
              <div style={{ fontSize: 11, color: 'var(--text4)', marginTop: 10 }}>El fuero y juzgado se copiarán automáticamente al incidente.</div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={() => setModalCrearPrincipal(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={guardarNuevoPrincipal} disabled={guardandoPrincipal || !formCrearPrincipal.caratula.trim()}>
                {guardandoPrincipal ? 'Guardando...' : 'Crear principal'}
              </button>
            </div>
          </div>
        </div>
      )}

{modalConfirmOpen && (
  <div className="modal-overlay" onMouseDown={e => e.target === e.currentTarget && setModalConfirmOpen(null)}>
    <div className="modal" style={{ width: 460 }}>
      <div className="modal-header">
        <div className="modal-title">⚠️ Atención</div>
        <button className="modal-close" onClick={() => setModalConfirmOpen(null)}>✕</button>
      </div>
      <div className="modal-body">
        <p style={{ fontSize: 14, color: 'var(--text2)', marginBottom: 12 }}>
          Estás por realizar una acción sobre el expediente:<br/>
          <strong>{modalConfirmOpen.caratula}</strong>
        </p>
        <div style={{ background: 'var(--red-light)', border: '0.5px solid #fecaca', borderRadius: 8, padding: '12px 14px', fontSize: 13, color: 'var(--red)', lineHeight: 1.6 }}>
          Borrar un expediente eliminará todas sus tareas y movimientos asociados. <strong>Esta acción no se puede deshacer.</strong>
        </div>
        <div style={{ background: 'var(--blue-light)', border: '0.5px solid #bfdbfe', borderRadius: 8, padding: '12px 14px', fontSize: 13, color: 'var(--blue)', lineHeight: 1.6, marginTop: 10 }}>
          💡 Recomendamos cambiar el estado del expediente a <strong>Archivado</strong> en lugar de eliminarlo, para conservar el historial.
        </div>
      </div>
      <div className="modal-footer" style={{ justifyContent: 'space-between' }}>
        {esAdmin && <button className="btn btn-danger" onClick={() => confirmarDeleteExpediente('eliminar', modalConfirmOpen.id, modalConfirmOpen.caratula)}>
          🗑 Eliminar definitivamente
        </button>}
        <div className="flex gap-2">
          <button className="btn btn-ghost" onClick={() => setModalConfirmOpen(null)}>Cancelar</button>
          <button className="btn btn-primary" onClick={() => confirmarDeleteExpediente('archivar', modalConfirmOpen.id, modalConfirmOpen.caratula)}>
            Archivar expediente
          </button>
        </div>
      </div>
    </div>
  </div>
)}
      {toast && (
        <div className="toast">✓ {toast.msg}</div>
      )}
    </div>
  );
}

function InfoTooltip({ text }) {
  const [visible, setVisible] = useState(false);
  return (
    <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
      <span
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        style={{
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          width: 16, height: 16, borderRadius: '50%',
          border: '1.5px solid var(--text4)', color: 'var(--text4)',
          fontSize: 10, fontWeight: 700, fontStyle: 'italic',
          cursor: 'default', flexShrink: 0, lineHeight: 1,
          userSelect: 'none', fontFamily: 'Georgia, serif',
        }}
      >i</span>
      {visible && (
        <div style={{
          position: 'absolute', left: '50%', bottom: 'calc(100% + 8px)',
          transform: 'translateX(-50%)',
          background: '#1e293b', color: '#f1f5f9',
          fontSize: 12, lineHeight: 1.5, fontWeight: 400, textTransform: 'none', letterSpacing: 'normal',
          padding: '8px 12px', borderRadius: 8,
          width: 260, boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
          zIndex: 999, pointerEvents: 'none',
          fontStyle: 'normal', fontFamily: 'inherit',
        }}>
          {text}
          <div style={{
            position: 'absolute', top: '100%', left: '50%', transform: 'translateX(-50%)',
            width: 0, height: 0,
            borderLeft: '6px solid transparent', borderRight: '6px solid transparent',
            borderTop: '6px solid #1e293b',
          }} />
        </div>
      )}
    </span>
  );
}